<div class="innerPagesBlock">
  <app-side-menu></app-side-menu>
  <div class="innerPagesRight customScroll" *ngIf="!loading; else loader">
    <!-- <app-banner-profile [viewType]="2" [businessID]="userBusinessDetails['business']?.id"
      [image]="'assets/images/logo.png'" [title]="'Admin Panel'"></app-banner-profile> -->
    <div class="innerpageContentBox mb-5">
      <form class="businessValidationformBox mb-3 filterform" [formGroup]="filterForm">
        <div class="innerpageContent">
          <div class="row">
            <div class="col-lg-3">
              <div class="inputGroup">
                <mat-form-field class="w-100 mat-input-group" appearance="outline">
                  <mat-label class="matLabel">Category </mat-label>
                  <mat-select multiple formControlName="productCategoryId">
                    <mat-option [value]="" *ngIf="categoryList.loading"><i>Loading ...</i></mat-option>
                    <mat-option *ngFor="let category of categoryList.response" [value]="category.id">
                      {{ category.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <!-- <div class="col-lg-3">
              <div class="inputGroup">
                <mat-form-field class="w-100 mat-input-group" appearance="outline">
                  <mat-label class="matLabel">Service Type </mat-label>
                  <mat-select formControlName="productTypeId">
                    <mat-option [value]="" *ngIf="productTypes.loading"><i>Loading ...</i></mat-option>
                    <mat-option *ngFor="let prod of productTypes.response" [value]="prod.id">
                      {{ prod.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div> -->
            <div class="col-lg-3">
              <div class="inputGroup">
                <mat-form-field
                  class="w-100 mat-input-group"
                  appearance="outline"
                >
                  <mat-label class="matLabel">Business Name </mat-label>
                  <mat-select multiple formControlName="businessName" [(ngModel)]="selectedOption" #select>
                    <input matInput (input)="onSearchInput($event)" placeholder="Enter business name" #searchInput />

                    <mat-option
                    *ngIf="filteredOptions.length === 0" [value]="null" style="pointer-events: none;" class="no-checkbox"
                  >
                      No options found
                  </mat-option>
                    <mat-option
                      *ngFor="let prod of filteredOptions"
                      [value]="prod.business_name"
                    >
                      {{ prod.business_name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-3" *ngIf="!this.approvedOnly">
              <div class="inputGroup" >
                <mat-form-field class="w-100 mat-input-group" appearance="outline">
                  <mat-label class="matLabel">Status </mat-label>
                  <mat-select multiple formControlName="validationStatusId">
                    <mat-option [value]="" *ngIf="productStatus.loading"><i>Loading ...</i></mat-option>
                    <mat-option *ngFor="let prod of productStatus.response" [value]="prod.id">
                      {{ prod.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-3 daterange">
              <div class="inputGroup">
                <!-- <mat-form-field class="w-100 mat-input-group" appearance="outline">
                  <mat-label class="matLabel">Reg Date (MM/DD/YYYY)</mat-label>
                  <input matInput [matDatepicker]="picker" formControlName="publishedAt">
                  <mat-hint>MM/DD/YYYY</mat-hint>
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field> -->

                <mat-form-field class="w-100 mat-input-group" appearance="outline">
                  <mat-label for="picker">Reg Date</mat-label>
                  <mat-date-range-input [rangePicker]="picker">
                    <input matStartDate style="font-size: 14px;" (click)="picker.open()" readonly formControlName="dateFrom" placeholder="Start date">
                    <input matEndDate style="font-size: 14px;" (click)="picker.open()" readonly formControlName="dateTo" placeholder="End date">
                  </mat-date-range-input>
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center">
          <div class="btnbx mt-5">
            <button type="button" class="btnThemeOutline blue me-3" (click)="resetFilter()">Reset</button>
            <button class="btnTheme red" (click)="handleFilter()">Search</button>
          </div>
        </div>
      </form>
      <div class="top-categeryHead">
        <div class="categeryHead-text">
          <h1 [innerHTML]="title"></h1>
        </div>
        <div class="btnGrpp">
          <div class="serchblk">
            <div class="searchInputbx">
              <input type="text" [value]="pageSearch" class="inputBox2" id="weburl" placeholder=""
                (input)="searchProductOnChange($event)" />
              <div class="removeico" (click)="clearSearch()" *ngIf="pageSearch"><img
                  src="assets/images/removeRoundgrey.svg" alt="Remove"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="admin-table">
        <div class="tableblock">
          <div class="text-center" *ngIf="this.loading">
            <div class="loader"></div>
          </div>
          <table class="adminPanel-table" *ngIf="!this.loading">
            <tr>
              <th>S.NO </th>
              <th>SERVICE NAME</th>
              <th>SERVICE DESCRIPTION</th>
              <th>CATEGORY</th>
              <th class="text-end">PRICE</th>
              <th>BUSINESS NAME</th>
              <th class="text-center">STATUS</th>
              <th class="text-center">SERVICE STATUS</th>
              <th class="text-center">ACTIONS</th>
            </tr>
            <div class="text-center" *ngIf="this.loading">
              <div class="loader"></div>
            </div>
            <ng-container *ngIf="!loading && services.length; else showEmptyView">
              <tr *ngFor="let service of services; index as i">
                <td class="serielNo text-center">{{ i + 1 }}</td>
                <td>

                      <div class="d-blocl">{{ service.name }}</div>
                </td>
                <td>
                  <p class="description d-blocl" [innerHtml]="service.description"> </p>
                  <!-- <button class="viewbbtn" *ngIf="getProductShortDescription(service.description)"
                    (click)="showProductDescription(service.description)">
                    Read More
                  </button> -->
                </td>
                <td><p class="d-blocl">{{ service.categories }}</p></td>
                <td class="text-end">
                  <div class="prodlist-prises align-items-end">
                    <p class="prod-mrp text-end">MRP</p>
                    <P class="prod-prise text-end"> ₹ {{ service.price }}</P>
                    <ng-container *ngIf="service.discounted_price">
                    <p class="prod-mrp text-end">HSP</p>
                    <P class="prod-prise text-end"> ₹ {{ service.discounted_price }}</P>
                    </ng-container>
                  </div>
                </td>
                <td><p class="d-blocl">{{ service.businessName }}</p></td>
                <td class="text-center">
                  {{ service.status || "" }}
                </td>
                <td class="text-center">
                  <div class="document-acceptence" [style.pointer-events] = "statusLoading !== 0 ? 'none' : ''">
                    <label class="switch" (click)="handleStatus($event, service)" *ngIf="statusLoading !== service.productId">
                      <input type="checkbox" id="togBtn" checked *ngIf="this.showStatus(service)"/>
                      <input type="checkbox" id="togBtn" *ngIf="!this.showStatus(service)"/>
                      <div class="slider round">
                        <span class="on">Active</span>
                        <span class="off">Inactive</span>
                      </div>
                    </label>
                  </div>
                  <div class="loader small" *ngIf="statusLoading === service.productId"></div>
                </td>
                <td class="text-center">
                  <div class="actions">
                    <button *ngIf="!this.approvedOnly" class="action" (click)="this.handleview(service.productId)">
                      <img src="./assets/images/eye-line.svg" alt="" />
                    </button>
                    <button class="action" (click)="this.showEditCard = service.productId">
                      <img src="./assets/images/edit-icon.svg" alt="" />
                    </button>
                    <!-- <button
                      class="action"
                      (click)="this.showDeleteModel = service.productId"
                    >
                      <img src="./assets/images/trash-icon.svg" alt="" />
                    </button> -->
                  </div>
                </td>
              </tr>
            </ng-container>
          </table>
        </div>
      </div>

      <div class="text-end my-4">
        <app-pagination class="mt-4 d-block" [currentPage]="currentPage" [totalItems]="totalRecords"
          [itemsPerPage]="pageLimit" (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)"></app-pagination>
      </div>
    </div>
  </div>

  <c-modal id="deleteDocumet" [visible]="this.showDeleteModel !== 0" backdrop="static" class="appModel"
    alignment="center">
    <div class="modelContentBox py-3 px-4" *ngIf="showDeleteModel !== 0">
      <div class="modelheader mb-3">
        <button (click)="this.showDeleteModel = 0" cButtonClose class="modelClose"></button>
      </div>
      <div class="modelBOdy">
        <div class="msgCont">
          <!-- <img src="./assets/images/checkmark.svg" alt=""> -->
          <p class="delmsg">Are you sure you want to delete?</p>
          <div class="btngr">
            <button type="button" (click)="this.showDeleteModel = 0" class="btnThemeOutline blue">
              No
            </button>
            <button type="button" class="btnTheme red" (click)="this.handleDelete()">
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>
  </c-modal>

  <!-- <c-modal
    id="descripton-pop"
    [visible]="showDescription"
    backdrop="static"
    class="appModel productListmodel"
    alignment="center"
  >
    <div class="modelContentBox py-3 px-4" *ngIf="showDescription">
      <div class="modelheader mb-8">
        <button
          cButtonClose
          class="modelClose"
          (click)="showDescription = false"
        ></button>
      </div>
      <div class="modelBOdy">
        <div [innerHtml]="description"></div>
      </div>
    </div>
  </c-modal> -->

  <!-- start add service -->
  <div class="agreeFrmSec">
    <c-modal id="addSeriviceDetails" [visible]="this.showAddPopup" *ngIf="this.showAddPopup" class="addpro"
      alignment="center" size="xl">
      <div class="modelContentBox py-3 px-4">
        <div class="modelheader mb-8">
          <button cButtonClose class="modelClose" (click)="this.handleAddService(false)"></button>
        </div>
        <div class="modelBOdy">
          <app-add-service [formTitle]="title2" *ngIf="this.showAddPopup" (resetListing)="this.resetListing()"
            (close)="this.handleAddService(false)"></app-add-service>
        </div>
      </div>
    </c-modal>
  </div>
</div>
<!-- end add service -->

<!-- start edit service -->
<c-modal id="editDetails" [visible]="this.showEditCard !== 0" backdrop="static" *ngIf="this.showEditCard !== 0" class="addpro"
  alignment="center" size="xl">
  <div class="modelheader mb-8">
    <!-- <button cButtonClose class="modelClose" (click)="this.handleEdit(0)"></button> -->
    <button class="modelClose" (click)="this.handleEdit(0)">

    <img width="20" class="position-absolute" style="right: 0;cursor: pointer;" src="../../../assets/images/close-blue.png" alt="">
    </button>
  </div>
  <div class="modelContentBox py-3 px-4">
    <div class="modelBOdy">
      <app-edit-service [formTitle]="title3" [selectedId]="this.showEditCard" (resetListing)="this.resetEditListing()"
        [viewMode]="false" (close)="this.handleEdit(0)"></app-edit-service>
    </div>
  </div>
</c-modal>
<!-- end edit service -->

<!-- start view service -->
<c-modal id="editDetails" [visible]="this.showDetailsCard !== 0" *ngIf="this.showDetailsCard !== 0" class="addpro"
  backdrop="static" alignment="center" size="xl">
  <div class="modelheader mb-8">
    <!-- <button cButtonClose class="modelClose" (click)="this.handleview(0)"></button> -->
    <button class="modelClose" (click)="this.handleview(0)">

    <img width="20" class="position-absolute" style="right: 0;cursor: pointer;" src="../../../assets/images/close-blue.png" alt="">
    </button>
  </div>
  <div class="modelContentBox py-3 px-4" *ngIf="preview == 0">
    <div class="modelBOdy">
      <app-edit-service [formTitle]="title4" [selectedId]="this.showDetailsCard"
        (resetListing)="this.resetEditListing()" (approve)="handleProductApprove($event)"
        (reject)="handleProductReject($event)" [viewMode]="true" (close)="this.handleview(0)" (popUp)="popUpEventHander($event)"></app-edit-service>
    </div>
  </div>
  <div class="modelContentBox py-3 px-4  text-center" *ngIf="preview == 1">
    <div class=" mb-3" style="position: absolute;right: 17px;">
        <!-- <button (click)="onPreview('', 0)" cButtonClose class="modelClose"></button> -->
        <button (click)="onPreview('', 0)" class="modelClose">

      <img width="20" class="position-absolute" style="right: 0;cursor: pointer;" src="../../../assets/images/close-blue.png" alt="">
        </button>
    </div>
    <img id="blah" [src]="previewImg" style="width: 450px;border-radius: 10px;" alt="your image"/>
</div>
</c-modal>
<!-- end view service -->

<ng-template #showEmptyView>
  <tr *ngIf="!loading">
    <td colspan="7">
      <div class="text-center p-3"><strong>No Service Found..</strong></div>
    </td>
  </tr>
</ng-template>
<ng-template #loader>
  <div class="shimmertext">
    <span class="loader"></span>
  </div>
</ng-template>

<c-modal id="toggleErrorPopup" [visible]="this.toggleErrorPopup" backdrop="static" class="appModel"
alignment="center">
<div class="modelContentBox py-3 px-4 thankokpop">
  <div class="modelheader mb-3 thankokHeader">
    <!-- <button (click)="this.hideModel()" cButtonClose class="modelClose"></button> -->
    <button (click)="this.hideModel()">
      <img width="20" class="position-absolute" style="right: 0;cursor: pointer;" src="../../../assets/images/close-blue.png" alt="">
    </button>
  </div>
  <div class="modelBOdy">
    <h4 class="thankokText">
      <img src="../../../assets/images/exclamation.png" />
    </h4>

    <div class="d-flex justify-content-center">
      <p class="mb-4">{{toggleErrorMsg}}</p>
    </div>
  </div>
</div>
</c-modal>
